import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/icon/up-right-from-square.svg'


const _hoisted_1 = { class: "col-11 col-sm-8 col-xl-6 mx-auto mt-5" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "お申込みフォーム")
], -1)
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("small", { class: "form-text text-muted" }, "メールに記載されている確認コードを入力してください。", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", {
  id: "nicotto-user-policy",
  class: "pdf"
}, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.faq.nicotto-admin.jp/faq/nicotto_無償トライアル利用規約［初版］.pdf",
    target: "_blank"
  }, [
    /*#__PURE__*/_createTextVNode(" nicotto_無償トライアル利用規約［初版］.pdf "),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      class: "external",
      alt: "新規ウインドウで開く",
      title: "新規ウインドウで開く"
    })
  ])
], -1)
const _hoisted_8 = { class: "form-check mt-3 form-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "agreement"
}, [
  /*#__PURE__*/_createTextVNode(" 規約に同意します。 "),
  /*#__PURE__*/_createElementVNode("span", { class: "badge bg-danger requiredText" }, "必須")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-primary col-4",
  type: "submit"
}, "申込み完了", -1)

import { Buffer } from 'buffer'
import { reactive, ref, unref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useNicotto, signUpConfirmInput } from '@/plugins/nicotto'
import { useMessenger } from '@/plugins/message'
import { useValidateForm } from '@/components/ui/validator'
import FormGroup from '@/components/ui/FormGroup.vue'
import InputEmail from '@/components/ui/InputEmail.vue'
import InputText from '@/components/ui/InputText.vue'
import InputPref from '@/components/ui/InputPref.vue'
import InputTel from '@/components/ui/InputTel.vue'
import InputPassword from '@/components/ui/InputPassword.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmView',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const nicotto = useNicotto()
const messenger = useMessenger()

const form = reactive<signUpConfirmInput>({
  email: '',
  code: '',
  prefecture: '',
  municipalityName: '',
  department: '',
  name: '',
  tel: '',
  password: ''
})
const agreement = ref(false)
const emailFromUrl = ref(false)

// クエリ引数からメールアドレスを取得
if (route.query?.em && typeof route.query.em=="string") {
  form.email = Buffer.from(route.query.em, 'base64').toString()
  emailFromUrl.value = true
}

const resendCode = async() => {
  if (form.email === '') {
    messenger.set('code.enterEmail')
  } else {
    try {
      await nicotto.auth.resendSignUp(form.email)
      messenger.set('code.sendSucceeded')
    } catch (err) {
      messenger.set('code.sendFailed')
    }
  }
}

const formRef = ref<HTMLFormElement>()
const onSubmit = async() => {
  const formUnref = unref(formRef) as unknown as HTMLFormElement
  if (useValidateForm(formUnref).isValid()) {
    try {
      await nicotto.auth.signUpConfirm(form)
      router.push('/application/complete')
    } catch (err) {
      switch (err.code) {
        case 'CodeMismatchException':
          messenger.set('code.mismatchException')
          setCodeValidation(formUnref)
          break;
        case 'ExpiredCodeException' || 'LimitExceededException':
          messenger.set('code.isExpired')
          setCodeValidation(formUnref)
          break;
        default:
          messenger.set('application.sendFailed')
          formUnref.classList.remove('was-validated')
          formUnref.querySelectorAll('.form-control').forEach(el => {
            el.classList.add('is-invalid')
          })
      }
    }
  }
}
const setCodeValidation = (formUnref:any) => {
  formUnref.classList.remove('was-validated')
  formUnref.querySelectorAll('.form-control, .form-select').forEach(el => {
    el.classList.add('is-valid')
  })
  let code = formUnref.querySelector('#code');
  code.classList.add('is-invalid')
  code.classList.remove('is-valid')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          ref_key: "formRef",
          ref: formRef,
          onSubmit: _withModifiers(onSubmit, ["prevent"]),
          novalidate: ""
        }, [
          _createVNode(FormGroup, {
            label: "メールアドレス",
            required: true,
            horizontal: false
          }, {
            default: _withCtx(() => [
              _createVNode(InputEmail, {
                modelValue: form.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.email) = $event)),
                required: true,
                disabled: emailFromUrl.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(FormGroup, {
            label: "確認コード",
            required: true,
            horizontal: false
          }, {
            default: _withCtx(() => [
              _createVNode(InputText, {
                modelValue: form.code,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.code) = $event)),
                id: "code",
                label: "確認コード",
                pattern: "^[0-9]+$",
                required: ""
              }, null, 8, ["modelValue"]),
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(FormGroup, {
            label: "都道府県",
            required: true,
            horizontal: false
          }, {
            default: _withCtx(() => [
              _createVNode(InputPref, {
                label: "都道府県",
                modelValue: form.prefecture,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.prefecture) = $event)),
                required: true
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(FormGroup, {
            label: "自治体名",
            required: true,
            horizontal: false
          }, {
            default: _withCtx(() => [
              _createVNode(InputText, {
                label: "自治体名",
                modelValue: form.municipalityName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.municipalityName) = $event)),
                required: true
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(FormGroup, {
            label: "部署名",
            required: true,
            horizontal: false
          }, {
            default: _withCtx(() => [
              _createVNode(InputText, {
                label: "部署名",
                modelValue: form.department,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.department) = $event)),
                required: true
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(FormGroup, {
            label: "担当者",
            required: true,
            horizontal: false
          }, {
            default: _withCtx(() => [
              _createVNode(InputText, {
                label: "担当者",
                modelValue: form.name,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.name) = $event)),
                required: true
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(FormGroup, {
            label: "電話番号",
            required: true,
            horizontal: false
          }, {
            default: _withCtx(() => [
              _createVNode(InputTel, {
                modelValue: form.tel,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.tel) = $event)),
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(FormGroup, {
            label: "パスワード",
            required: true,
            horizontal: false
          }, {
            default: _withCtx(() => [
              _createVNode(InputPassword, {
                modelValue: form.password,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.password) = $event)),
                autocomplete: "new-password",
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((agreement).value = $event)),
              class: "form-check-input",
              type: "checkbox",
              id: "agreement",
              required: ""
            }, null, 512), [
              [_vModelCheckbox, agreement.value]
            ]),
            _hoisted_9
          ]),
          _createElementVNode("div", { class: "d-flex justify-content-evenly mt-5 mb-3" }, [
            _createElementVNode("button", {
              class: "btn btn-light col-4",
              type: "button",
              onClick: resendCode
            }, "確認コード再送"),
            _hoisted_10
          ])
        ], 40, _hoisted_5)
      ])
    ])
  ]))
}
}

})